// extracted by mini-css-extract-plugin
export default {"notice":"AuthContext_notice__+iu66","loginLink":"AuthContext_loginLink__vMHu4"};